<template>
    <v-menu
        activator="#app-bar-cart"
        :open-on-click="false"
        :open-on-hover="false"
        :model-value="modelValue"
        location="bottom end"
        :width="$vuetify.display.lgAndUp ? 670 : '100%'"
        :max-width="$vuetify.display.lgAndUp ? 670 : undefined"
        @update:model-value="emit('updateMenu', $event)"
        class="full-overlay"
        @mouseenter="() => {
            enteredOverlay = true;
        }"
        @mouseleave="() => {
            enteredOverlay = false;
            emit('updateMenu', false)
        }"
    >
        <v-card
            id="cart-card"
            elevation="0"
            :rounded="$vuetify.display.lgAndUp ? 'lg' : 0"
            class="rounded-te-0 pb-8 overflow-x-hidden"
            :class="{
                'w-100': $vuetify.display.mdAndDown,
                'empty-cart': !cartStore.cartItems.length
            }"
        >
            <div
                :class="{'empty-cart': !cartStore.cartItems.length}"
                class="pt-8 text-body-1 pb-0"
            >
                <div v-if="!cartStore.cartItems.length" class="d-flex flex-column ga-4 text-grey-darken-1 text-body-1 pl-4 pr-4">
                    <div class="text-h5 font-weight-black">
                        {{$t('eshop::order-cart.cart_empty')}}
                    </div>
                    <div v-html="$t('eshop::order-cart.cart_empty_subtitle', {href: route('contact')})"></div>
                </div>
                <div v-else class="text-grey-darken-1 font-weight-black">
                    <div class="px-8">
                        {{$t('eshop::order-cart.you_have')}}
                    </div>
                    <v-list
                        density="default"
                        lines="three"
                        class="pb-0"
                    >
                        <template v-for="item in cartStore.cartItems"
                                  :key="item.id">
                            <product-item
                                :product="item.products"
                                :name="item.products.name"
                                :image="item.products.main_image.url"
                                :stock_number="item.products.stock_number"
                                :price="item.nice_price"
                                :href="item.products.url"
                            ></product-item>
                            <v-divider></v-divider>
                        </template>
                    </v-list>
                </div>
            </div>
            <template v-if="cartStore.cartItems.length">
                <free-delivery v-if="$page.props.order?.free_delivery_diff !== false" :remaining="$page.props.order?.free_delivery_diff" percentage-override
                               :percents="$page.props.order?.free_delivery_percentage"></free-delivery>
                <div class="px-8 d-flex justify-end">
                    <div id="cart-summary" class="d-flex flex-column mt-8 text-body-2 text-grey-darken-1">
                        <div v-if="cartStore.couponItem" class="d-flex align-center justify-space-between ga-3">
                            <span class="font-weight-bold">{{$t('eshop::order-cart.coupon')}} ({{cartStore.couponItem.name}})</span><price-hider small><span class="font-weight-black">{{ cartStore.couponItem.nice_price }}</span></price-hider>
                        </div>
                        <div class="d-flex align-center justify-space-between ga-3">
                            <span class="font-weight-bold">{{$t('eshop::order-cart.total_with_vat')}}</span><price-hider small><span class="font-weight-black text-h6">{{ $page.props.order.nice_total_price }}</span></price-hider>
                        </div>
                        <div class="d-flex align-center justify-space-between ga-3 text-grey">
                            <span>{{$t('eshop::order-cart.total_without_vat')}}</span><price-hider small><span>{{ $page.props.order.nice_total_price_without_vat }}</span></price-hider>
                        </div>
                        <Link :href="route('order.cart')" @click="emit('cartClick')" class="mt-6 d-block text-decoration-none">
                            <v-btn
                                block
                                color="success"
                                elevation="0"
                                class="text-body-1"
                                size="x-large"
                                :append-icon="mdiArrowRight"
                            >
                                {{$t('eshop::order-cart.go_to_cart')}}
                            </v-btn>
                        </Link>
                    </div>
                </div>
            </template>
        </v-card>
    </v-menu>
    <v-overlay
        :model-value="modelValue"
        scrim="#000"
        :attach="true"
        @click="emit('updateMenu', false)"
        @mouseenter="debounceCartDestroy"
        @update:model-value="emit('updateMenu', $event)"
    ></v-overlay>
</template>

<script setup>
import {inject, onMounted, ref, toRefs} from "vue";
import {useCartStore} from "../../../motonet/modules/eshop/store/cart";
import pinia from "../../../plugins/pinia";
import ProductItem from "./ProductItem.vue";
import FreeDelivery from "./FreeDelivery.vue";
import {Link} from "@inertiajs/vue3";
import {mdiArrowRight} from "@mdi/js";
import PriceHider from "../../../motonet/modules/eshop/frontend/PriceHider.vue";

const props = defineProps({
    modelValue: Boolean
})
const emit = defineEmits(['updateMenu', 'cartClick']);
const cartStore = useCartStore(pinia);
const route = inject('route');
onMounted(()=> {
    document.querySelector('.c-overlay')?.addEventListener('click', () => {
        emit('updateMenu', false)
    })
})
const enteredOverlay = ref(false);
const debounceCartDestroy = () => {
    setTimeout(() => {
        if(!enteredOverlay.value) {
            emit('updateMenu', false)
        }
    }, 200)
}
</script>

<style scoped lang="scss">
@use '../../../plugins/vuetify-settings' as *;
@use 'vuetify/lib/styles/settings/variables' as *;
@use 'sass:map';
#cart-card{
    max-height: calc(100vh - 150px);
    &.empty-cart {
        background-image: url('./../../../assets/images/cart/ajajaj.png');
        background-position: left center;
        background-repeat: no-repeat;
        background-size: contain;
        > div {
            padding-left: 183px;
        }
        @media screen and (max-width: 720px) {
            background-image: none;
            & > div {
                padding-left: $spacer * 4;
            }
        }
    }
}

#cart-summary{
    flex: 0 1 50%;
    @media #{map.get($display-breakpoints, 'md-and-down')} {
        flex-grow: 1;
    }
}
</style>
